/**
 * The documents a customer reads and accepts before a test drive.
 *
 * ONE list, read by both Settings → Test drive documents and the check-in
 * Agreement step, so the two can never show different forms.
 *
 * These are SAMPLE placeholders (public/test-drive-docs/*.pdf) until the
 * dealership confirms its real four documents. To change them: replace the PDFs
 * and edit this list — nothing else in the app names a document.
 *
 * `short` is the label recorded with the customer's signature, so it is kept
 * compact (the capture label is capped at 120 characters).
 */
const BASE = `${import.meta.env.BASE_URL || '/'}test-drive-docs/`;

export const TEST_DRIVE_DOCUMENTS = [
  {
    id: 'agreement',
    short: 'Agreement & waiver',
    title: 'Test Drive Agreement and Liability Waiver',
    description: 'The rules of the drive: licence, route, fines, no other drivers, returning the car on time.',
    file: `${BASE}1-test-drive-agreement.pdf`,
  },
  {
    id: 'insurance',
    short: 'Insurance excess',
    title: 'Insurance Excess and Liability Acknowledgement',
    description: 'What the customer may be liable for if the vehicle is damaged while in their care.',
    file: `${BASE}2-insurance-excess-acknowledgement.pdf`,
  },
  {
    id: 'licence',
    short: 'Licence verification',
    title: 'Driver Licence Verification and Copy Consent',
    description: 'Confirms the licence was checked and the customer consents to a record being kept.',
    file: `${BASE}3-licence-verification.pdf`,
  },
  {
    id: 'privacy',
    short: 'Privacy notice',
    title: 'Privacy Collection Notice and Consent',
    description: 'What personal information is collected, why, who sees it and how to withdraw consent.',
    file: `${BASE}4-privacy-notice.pdf`,
  },
];
